<template>
   <GetInfo v-if="!isSubmit" @updateIsSubmit="updateIsSubmit" :channel="channel" :operationCode="operationCode"></GetInfo>
   <GetInfoSuccessed :channel="channel" v-else></GetInfoSuccessed>
</template>
  
  <script>
  import GetInfo from './GetInfo.vue';
  import GetInfoSuccessed from './GetInfoSuccessed.vue';
  import Fingerprint2 from 'fingerprintjs2'; // 引入fingerprintjs2
  import { getQuery } from '//common/utils/url';
  import servers from './servers';
  export default {
    name: 'GetInfomation',
    components: {
      GetInfo,
      GetInfoSuccessed
    },
    props: {
    },
    data () {
      return {
        isSubmit: false,
        channel: '',
        sign: '',
        deviceId: '',
        operationCode: '',
      }
    },
    methods: {
      updateIsSubmit() {
        this.isSubmit = true
      },
      // 创建浏览器指纹
      async createFingerprint() {
        // 浏览器指纹
        return new Promise((resolve) => {
            Fingerprint2.get((components) => { // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
            const values = components.map(component => component.value); // 配置的值的数组
            const murmur = Fingerprint2.x64hash128(values.join(''), 31); // 生成浏览器指纹
            // sessionStorage.setItem('_deviceId', murmur); // 存储浏览器指纹，在项目中用于校验用户身份和埋点
            resolve(murmur);
          });
        })
      },
      // 获取渠道信息
      getChannelInfo() {
        this.channel = getQuery('channel') || ''
        this.sign = getQuery('sign') || ''
      }
    },
    beforeCreate() {
    },
    created() {
      this.getChannelInfo();
      this.createFingerprint()
      .then((deviceId) => {
        return servers.loadOperation({
          deviceId,
          channel: this.channel,
          sign: this.sign
        });
      }).then(data => {
        this.operationCode = data.operationCode;
        sessionStorage.setItem('_token_operationCode', data.operationCode)
      });
    },
    mounted() {
    }
  }
  </script>
  
  <style>
    @media only screen and (max-width: 1180px) {
      .get-info-container {
        width: 80%!important;
        /* height: 1000px; */
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 0.32rem;
        padding: 0.2rem 0.5rem;
        border: 1px solid #ccc;
      }
      .get-info-container .get-info-content-header img {
        width: 2.6rem;
        max-width: 3.2rem;
      }
      .get-info-container .get-info-content-header .header-successed-title {
        font-size: 0.38rem;
      }
      .get-info-container .el-form-item__content {
        line-height: 0.72rem;
        font-size: 0.25rem;
      }
      .get-info-container .el-form-item__content .el-input {
        font-size: 0.25rem;
      }
      .get-info-container .el-form-item__content .el-input input {
        height: 0.72rem;
        border-width: 0.02rem;
        border-radius: 0.08rem;
      }
      .get-info-container .el-form-item__content .el-select .el-input__icon {
        margin-right: 0.16rem;
        padding-right: 0.16rem;
      }
      .get-info-container .phone-code-content button {
        width: 3rem!important;
        max-width: 3rem!important;
        min-width: 2rem!important;
        font-size: 0.25rem;
        /* padding: 0.24rem, 0.4rem; */

      }
      .get-info-content-footer .submit-btn {
        height: 0.8rem;
      }
      .img-code-content img {
        width: 2.04rem!important;
        max-width: 2.04rem!important;
        min-width: 2.04rem!important;
        overflow: hidden;
      }
      .el-message, .el-message p {
        font-size: 0.2rem;
      }
    }
    

    /* form 布局 */
    .get-info-container .el-form-item {
      margin-bottom: 0.2rem;
    }
    .get-info-container .phone-code-content .el-form-item__content, .el-form-item__content {
      display: flex;
    }
    .get-info-container .el-form-item__content, .get-info-container .el-form-item__content .el-select {
      width: 100%;
    }
    .get-info-container .el-form-item__content .el-select .el-input__icon {
      font-size: 0.32rem;
      line-height: 0.7rem;
    }
    /* 下拉 */
    .el-select-dropdown__empty {
      font-size: 0.25rem;
    }
    .el-select-dropdown .el-select-dropdown__item {
      height: 0.5rem;
      font-size: 0.25rem;
      line-height: 0.5rem;
    }
    /* 验证码btn */
    .get-info-container .phone-code-content button {
      width: 2.4rem;
      max-width: 2.4rem;
      min-width: 2.4rem;
      /* min-width: 140px; */
      margin-left: 0.2rem;
      padding: 0.24rem 0.2rem;
      border-radius: 0.08rem;
    }
  </style>
  